import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { TextmodulesService, TextSnippet } from 'src/app/_provider/textmodules/textmodules.service';

@Component({
  selector: 'app-content-text-module-preview',
  templateUrl: './content-text-module-preview.page.html',
  styleUrls: ['./content-text-module-preview.page.scss'],
})
export class ContentTextModulePreviewPage implements OnInit {

  public snippet: TextSnippet

  constructor(
    private modalSrv: ModalController,
    private feedback: FeedbackService,
    private textModuleSrv: TextmodulesService
  ) { }

  async ngOnInit() {
    if(!this.snippet) return await this.feedback.showError("Es wurde kein Textbaustein angegegebn.")
    await this.feedback.showLoading(async () => {
      const result: HttpFunctionResult<TextSnippet> = await this.textModuleSrv.getSnippetById(this.snippet.id)
      if(!result.success) return

      this.snippet = result.data

    }, "Laden...")
  }

  public async back(){
    await this.modalSrv.dismiss()
  }

}
